module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_600.eb4ae3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/fullscreen-image_hero_600.png
// module id = XHyw
// module chunks = 0